import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useLocalStorage } from 'hooks/localstorage';
import Image from 'next/image';
import Timer from './display';
import Faq from '../faq';
import Rating from '../rating';
import SimpleDisplay from './simpledisplay';
import { useTranslations } from 'next-intl';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { countdownsState } from 'store/atoms';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Snackbar from '@mui/material/Snackbar';






export default function Main({ dataQuery, lang_code, page_content, embed = false, faq = [] }) {
    const t = useTranslations();
    const fullscreenfn = useFullScreenHandle();
    const fullscreenfn1 = useFullScreenHandle();
    const countdowns = useRecoilValue(countdownsState);
    const setCountdowns = useSetRecoilState(countdownsState);
    const [lscountdowns, setLscountdowns] = useLocalStorage("lscountdowns");

    const router = useRouter();
    const [removed, setRemoved] = useState(false);
    const [open, setOpen] = useState(false);
    const [openMore, setOpenMore] = useState(false);
    const [mounted, setMounted] = useState(false);





    useEffect(() => {
        setMounted(true);

        // console.log("useEffect countdowns", countdowns);
        if (countdowns.length === 0 && lscountdowns && lscountdowns.length > 0) {
            setCountdowns([...lscountdowns])
        }
        setLscountdowns([...countdowns])


    }, [countdowns]);





    const openDisplay = () => {
        setOpen(true);
        setOpenMore(true);
    };

    const cancelDisplay = () => {
        setOpen(false);
        setOpenMore(false);
    }

    const removeTimer = (index) => {
        let new_list = [...countdowns];
        new_list.splice(index, 1);
        setCountdowns([...new_list]);
        setLscountdowns([...new_list]);
        setRemoved(true);
    };

    const timer_info = [{
        icon: (<Image width="43px" alt='several' height="43px" src={'/images/icon_several.svg'} />
        ),
        text: t('key_countdown_info_1')
    }, {
        icon: (<Image width="43px" height="43px" alt='customizable' src={'/images/icon_customizable.svg'} />),
        text: t('key_countdown_info_2')
    }, {
        icon: (<Image width="43px" height="43px" alt='share' src={'/images/icon_share.svg'} />),
        text: t('key_countdown_info_3')
    }];




    return (
        <>
            <div className="timer-container countdown-container-main">
                {!dataQuery && <div className='available-timers'>
                    {mounted && countdowns && countdowns.length > 0 && countdowns.map((v, i) => {
                        return (
                            <SimpleDisplay
                                fullscreenfn={fullscreenfn1}
                                singleTimer={countdowns && countdowns.length ? countdowns.length : 0}
                                timer={v}
                                index={i}
                                key={i}
                                removeItem={removeTimer}
                            />)
                    })}
                </div>}
                <FullScreen handle={fullscreenfn}>

                    {<div>
                        <Timer _openmore={openMore} alreadyAdded={countdowns && countdowns.length > 0 ? true : false} fullscreenfn={fullscreenfn} cancelDisplay={cancelDisplay} />
                    </div>}
                </FullScreen>

                {dataQuery && <div className='available-timers'>
                    {mounted && (
                        <SimpleDisplay
                            fullscreenfn={fullscreenfn1}
                            singleTimer={1}
                            shared={true}
                            timer={dataQuery}
                            index={0}

                        />)}
                </div>}


                {!embed && <> <div className="ad-container my-container small-ad">
                    <div className="ad-text">980x120<br />ad</div>
                </div>
                    <div className="my-container info-block m-top-40">
                        {timer_info.map((v, i) => {
                            return (<div key={i} className="info-block-each">
                                <div className="info-block-each-icon">{(i + 1)})</div>
                                <div className="info-block-each-text">{v.text}</div>
                            </div>)
                        })}
                    </div>
                    <div className="ad-container my-container md-ad">
                        <div className="ad-text">930x180<br />ad</div>
                    </div>
                    <div className='my-container m-top-28 page-content-coantainer' dangerouslySetInnerHTML={{ __html: page_content.replace('TimerTone.com', `<a name="timertone" href="//${lang_code}.timertone.${process.env.NEXT_PUBLIC_DOMAIN_SUFFIX}/dashboard/alarm">TimerTone.com</a>`) }}>

                    </div>
                    {<Faq faq={faq} from={'countdown'} lang_code={lang_code} />}

                </>}
            </div>
            <Snackbar
                open={removed}
                autoHideDuration={5000}
                message={t('key_timer_removed')}
                onClose={() => setRemoved(false)}
            />
        </>
    )
}






